import InventoryIndex from './InventoryIndex';

export default InventoryIndex;
